import { render } from "./SystemColorPickerView.vue?vue&type=template&id=32ecada8&scoped=true&ts=true"
import script from "./SystemColorPickerView.vue?vue&type=script&lang=ts"
export * from "./SystemColorPickerView.vue?vue&type=script&lang=ts"

import "./SystemColorPickerView.vue?vue&type=style&index=0&id=32ecada8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32ecada8"]])

export default __exports__